import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

export const ErrorScreen = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const ErrorIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: #fef2f0;
`;

export const ErrorTitle = styled.div`
    ${({ theme }) => theme.typography.Headline};
    margin: 40px 0 16px;
`;

export const ErrorContent = styled.div`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
    flex: 1;
`;

export const ErrorCta = styled(ButtonV2)``;
